import { Controller, type FieldValues } from 'react-hook-form';
import { type ComboboxControllerProps } from './types';
import { Combobox } from './index';

export const ComboboxController = <T extends FieldValues>({
  name,
  control,
  rules,
  options,
  multiple,
  searchable,
  label,
  helperText,
  required,
  placeholder,
  searchPlaceholder,
  emptyMessage,
  className,
  disabled,
  variant,
  leftIcon,
  leftSlot,
}: ComboboxControllerProps<T>): React.ReactElement => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <Combobox
        options={options}
        multiple={multiple}
        searchable={searchable}
        value={field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
        ref={field.ref}
        label={label}
        helperText={helperText}
        required={required}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        emptyMessage={emptyMessage}
        className={className}
        disabled={disabled}
        variant={variant}
        leftIcon={leftIcon}
        leftSlot={leftSlot}
      />
    )}
  />
);
